import React, { useMemo } from "react"
import Card from "@react/shared/ui/Card"

const formatAmount = (cents, symbol = "€") => {
  const value = (cents / 100).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 0 })
  return `${value} ${symbol}`
}

const KpiStrip = ({ groups, currencySymbol }) => {
  const kpis = useMemo(() => {
    let totalInit = 0
    let totalPrev = 0
    let totalCumul = 0
    groups.forEach(group => group.services.forEach(service => {
      totalInit  += service.init_cents
      totalPrev  += service.prev_cents
      totalCumul += Math.round((service.init_cents * service.draftPct) / 100)
    }))
    const remaining = Math.max(0, totalInit - totalCumul)
    const progressPct = totalInit > 0 ? Math.round((totalCumul / totalInit) * 100) : 0
    return { totalInit, totalPrev, totalCumul, remaining, progressPct }
  }, [groups])

  return (
    <div className="grid grid-cols-4 gap-3">
      <Card className="p-4">
        <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-400">
          {I18n.t("projects.situations.kpis.total_initial")}
        </div>
        <div className="mt-2 text-[20px] font-semibold text-slate-900 tabular-nums">
          {formatAmount(kpis.totalInit, currencySymbol)}
        </div>
        <div className="text-[11.5px] text-slate-500 mt-1">{I18n.t("projects.situations.kpis.ht_suffix")}</div>
      </Card>

      <Card className="p-4">
        <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-400">
          {I18n.t("projects.situations.kpis.cumul_billed")}
        </div>
        <div className="mt-2 text-[20px] font-semibold text-slate-900 tabular-nums">
          {formatAmount(kpis.totalPrev, currencySymbol)}
        </div>
        <div className="text-[11.5px] text-slate-500 mt-1 tabular-nums">
          {kpis.totalInit > 0 ? `${Math.round((kpis.totalPrev / kpis.totalInit) * 100)}%` : "—"}
        </div>
      </Card>

      <Card className="p-4">
        <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-400">
          {I18n.t("projects.situations.kpis.remaining")}
        </div>
        <div className="mt-2 text-[20px] font-semibold text-slate-900 tabular-nums">
          {formatAmount(kpis.remaining, currencySymbol)}
        </div>
        <div className="text-[11.5px] text-slate-500 mt-1">{I18n.t("projects.situations.kpis.ht_suffix")}</div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div className="text-[10.5px] uppercase tracking-wider font-semibold text-slate-400">
            {I18n.t("projects.situations.kpis.global_progress")}
          </div>
        </div>
        <div className="mt-2 text-[20px] font-semibold text-slate-900 tabular-nums">
          {kpis.progressPct}<span className="text-slate-400 text-[15px] ml-1">%</span>
        </div>
        <div className="mt-3 h-1.5 rounded-full bg-slate-100 overflow-hidden">
          <div className="h-full bg-slate-900 rounded-full" style={{ width: `${kpis.progressPct}%` }} />
        </div>
      </Card>
    </div>
  )
}

export default KpiStrip
